import ScientificCouncilDeleteModal from "./ScientificCouncilDeleteModal";

export default ScientificCouncilDeleteModal;

